import React, { useEffect, useState, useCallback } from 'react'
import { connect } from "react-redux";
import { useToasts } from 'react-toast-notifications';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faVideo } from '@fortawesome/free-solid-svg-icons';
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import { useLazyQuery, useMutation } from '@apollo/client';
import { Form } from 'react-bootstrap';
import Swal from "sweetalert2";

import { errorTitleWithTextSwal } from "../../../helpers/sweetalert";
import { updateFbdata, removeFbdata, updateFbFeedList } from "../../../redux/fbdata/fbdata.action";
import ErrorPermissionModal from '../../../components/ErrorPermissionModal';
import SELECT_PAGE_IMAGE from "../../../image/SELECT_PAGE_IMAGE.png";
import { UPDATE_LIVE } from '../../../graphql/live/mutation';
import { SHOP } from '../../../graphql/shop/queryShop';
import { GET_LIVE_STOCKS } from '../../../graphql/liveStock/query';
import moment from 'moment';
import { COLOR_APP } from '../../../constants';
import { useInitFbSDK } from '../../../helpers/fb-hooks';
import { fetchAllFbPages, readShopPagesRaw, saveShopPages } from "../../../helpers/shopPages";

function SelectPageForLive(props) {
  const { history, location } = useReactRouter();
  const LIVE_DATA = location.state

  const isFbSDKInitialized = useInitFbSDK();

  const [fbUserAccessToken, setFbUserAccessToken] = useState("");
  const [showErrorPermissionModal, setShowErrorPermissionModal] = useState(false);
  const [selectedPage, setSelectedPage] = useState({});
  const [assignedPageList, setAssignedPageList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedLive, setSelectedLive] = useState();
  const [isContinue, setIsContinue] = useState(false);

  const { addToast } = useToasts();

  const [updateLive] = useMutation(UPDATE_LIVE);
  const [getShop, { data: shopValidatedData }] = useLazyQuery(SHOP, { fetchPolicy: "cache-and-network" });
  const [getLiveShopStockForValidate, { data: liveShopStockDataForValidate }] = useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });

  useEffect(() => {
    const shopPageCookie = readShopPagesRaw();
    const _assignedPageList = shopPageCookie ? JSON.parse(shopPageCookie) : [];
    // const _assignedPageList = JSON.parse(readShopPagesRaw())  || []
    // const _assignedPageList = JSON.parse(localStorage.getItem('SHOP_PAGE'));
    setAssignedPageList(_assignedPageList)
  }, [])

  useEffect(() => {
    if (fbUserAccessToken) {
      // console.log("get page list");
      fetchAllFbPages(fbUserAccessToken, async ({ data }) => {
          window.FB.api(`/me?access_token=${fbUserAccessToken}`,
            async (userData) => {
              let _newData = [...data];
              saveShopPages(_newData); // screens showing the page list refresh at once
              updateFbFeedList({ assignedPageList: _newData });
            }
          );
        }
      );
    }
  }, [fbUserAccessToken]);

  useEffect(() => {
    // console.log("isFbSDKInitialized: ", isFbSDKInitialized);
    if (isFbSDKInitialized) {
      window.FB.getLoginStatus((response) => {
        // console.log("response.authResponse: ", response.authResponse);
        if (response.authResponse)
          setFbUserAccessToken(response.authResponse?.accessToken);
        else
          errorTitleWithTextSwal(
            "ມີຂໍ້ຜິດພາດ",
            "ໃນການເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກ ລອງໃຫມ່ອີກຄັ້ງ"
          );
      });
    }
  }, [isFbSDKInitialized]);

  useEffect(() => {
    if (shopValidatedData) {
      if (shopValidatedData?.shop?.paymentType == "POINT") {
        if (shopValidatedData?.shop?.point <= 0) {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "ຄະແນນຂອງທ່ານບໍ່ພຽງພໍ!",
            html:
              `<div className="text-left">ກະລຸນາເຕີ່ມຄະແນນກ່ອນ ຈຶ່ງສາມາດເລີ່ມຕໍ່ການ Live ໄດ້ <br/>` +
              "ຕິດຕໍ່ຫາພວກເຮົາ ເພື່ອເຕີມຄະແນນ ຫຼື ປ່ຽນເພັກເກັດໃໝ່ໃນການນຳໃຊ້ລະບົບ<br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          return;
        }
      }
      if (shopValidatedData?.shop?.paymentType == "SUBSCRIPTION") {
        if (moment().diff(shopValidatedData?.shop?.endDate, "days") > 0) {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "ໄລຍະເວລາການໃຊ້ງານຂອງທ່ານສິ້ນສຸດແລ້ວ!",
            html:
              `<div className="text-left">` +
              "ຕິດຕໍ່ຫາພວກເຮົາ ເພື່ອເຕີມຄະແນນ ຫຼື ປ່ຽນເພັກເກັດໃໝ່ໃນການນຳໃຊ້ລະບົບ<br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          return;
        }
      }
      getLiveShopStockForValidate({
        variables: {
          where: {
            live: selectedLive?.id,
          },
        },
      });
    }
  }, [shopValidatedData]);

  useEffect(() => {
    if (liveShopStockDataForValidate) {
      // Check if live has no liveproduct will not allow to start live
      let _liveStockList = liveShopStockDataForValidate?.liveStocks?.data;

      if (_liveStockList?.length == 0) {
        Swal.fire({
          icon: "error",
          title: "ບໍ່ມີສິນຄ້າທີ່ຈະຂາຍໃນໄລຟ",
          html:
            `<div className="text-left">STEP1: ເພີ່ມສິນຄ້າທີ່ຈະຂາຍໃນໄລຟນີ້ກ່ອນ<br/>` +
            "STEP2 : ເລີ່ມໄລຟຂາຍເຄື່ອງໄດ້ເລີຍ <br/>" +
            "</div>",
          showConfirmButton: false,
          timer: 20000,
        });
        setIsLoading(false);
        return;
      }

      // Check if stock does not exist in warehouse
      let checkStockExistError = false;
      _liveStockList.map(async (lProduct) => {
        if (lProduct?.stock?.isDeleted) {
          checkStockExistError = true;
        }
      });
      if (checkStockExistError) {
        Swal.fire({
          icon: "error",
          title: "ມີສິນຄ້າທີ່ຖືກລຶບອອກຈາກສະຕ໊ອກແລ້ວໃນໄລຟນີ້",
          html:
            `<div className="text-left">STEP1: ແກ້ໄຂໄລຟນີ້ ຫຼື ສ້າງໄລຟໃຫມ່<br/>` +
            "STEP2 : ລຶບສິນຄ້ານັ້ນອອກ <br/>" +
            "</div>",
          showConfirmButton: false,
          timer: 20000,
        });
        setIsLoading(false);
        return;
      }

      // Check if User is not login with facebook
      if (!fbUserAccessToken) {
        Swal.fire({
          icon: "error",
          title: "ກະລຸນາເຊື່ອມຕໍ່ກັບ Facebook ກ່ອນ!",
          html:
            `<div className="text-left">STEP1: ກົດປຸ່ມ ເຊື່ອມFacebook ຢູ່ມຸມຂວາເທິງຂອງຫນ້ານີ້ <br/>` +
            "STEP2 : ປ້ອນຂໍ້ມູນບັນຊີຂອງເຟສບຸກຂອງທ່ານ <br/>" +
            "</div>",
          showConfirmButton: false,
          timer: 20000,
        });
        setIsLoading(false);
        return;
      }

      // Check if no page selected
      if (!selectedPage?.id) {
        Swal.fire({
          icon: "error",
          title: "ເລືອກເພຈທີ່ທ່ານຕ້ອງການໄລຟສົດ",
          html:
            `<div className="text-left">STEP1: ເລືອກເພຈທີ່ຕ້ອງການໄລຟໃສ່ກັບຂໍ້ມູນທີ່ສ້າງມາ <br/>` +
            "" +
            "</div>",
          showConfirmButton: false,
          timer: 20000,
        });
        setIsLoading(false);
        return;
      }
      let _pageIndex = _.findIndex(assignedPageList, { id: selectedPage.id });

      // Update page data to live in database
      _updatePageToLive(assignedPageList[_pageIndex])

      setTimeout(() => {
        try {
          // Check if facebook page has live video
          if (assignedPageList[_pageIndex].isPrivate) {
            window.FB.api(`/${assignedPageList[_pageIndex].id}/videos?fields=title,id,live_status,status&access_token=${assignedPageList[_pageIndex].access_token}`,
              (response) => {
                if (response?.error) {
                  addToast("ຜິດພາດ ກະລຸນາເຊື່ອມ Facebook ໃຫມ່ແລ້ວລອງໃຫມ່ອີກຄັ້ງ!", {
                    appearance: "warning",
                    autoDismiss: true,
                  });
                  setIsLoading(false);
                  return;
                }
                const data = response?.data || [];
                let isLiveAvailable = false;
                if (data) {
                  data.map((vdo) => {
                    if (vdo.status == "LIVE") isLiveAvailable = true;
                  });
                }
                setIsLoading(false);
                if (isLiveAvailable)
                  history.push(`/live-screen/${LIVE_DATA?.id}`, {
                    live: LIVE_DATA,
                    page: assignedPageList[_pageIndex],
                    isContinue: false,
                  });
                else {
                  setIsLoading(false);
                  Swal.fire({
                    icon: "error",
                    title: "ບໍ່ມີໄລຟສົດໃນເພຈເທື່ອ!",
                    html:
                      `<div className="text-left">STEP1: ໄປທີ່ page (${assignedPageList[_pageIndex].name}) <br/> ` +
                      "STEP2 : ເລີ່ມໄລຟວິດີໂອແລ້ວລໍຖ້າຈົນກວ່າການກະກຽມນັ້ນສໍາເລັດ<br/>" +
                      "STEP3 : ກັບຄືນມາຫນ້ານີ້ແລ້ວກົດ ເລີ່ມໄລຟ ໄດ້ເລີຍ</div>",
                    showConfirmButton: false,
                    timer: 20000,
                  });
                }
              }
            );
          } else {
            window.FB.api(`/${assignedPageList[_pageIndex].id}/videos?fields=title,id,status,live_status&access_token=${assignedPageList[_pageIndex].access_token}`,
              (response) => {
                if (response?.error) {
                  addToast("ຜິດພາດ ກະລຸນາເຊື່ອມ Facebook ໃຫມ່ແລ້ວລອງໃຫມ່ອີກຄັ້ງ!", {
                    appearance: "warning",
                    autoDismiss: true,
                  });
                  setIsLoading(false);
                  return;
                }
                const data = response?.data || [];
                if (data) {
                  let isLiveAvailable = false;
                  data.map((vdo) => {
                    if (vdo.live_status == "LIVE") isLiveAvailable = true;
                  });
                  setIsLoading(false);
                  if (isLiveAvailable) {
                    history.push(`/live-screen/${LIVE_DATA?.id}`, {
                      live: LIVE_DATA,
                      page: assignedPageList[_pageIndex],
                      isContinue: false,
                    });
                  } else {
                    setIsLoading(false);
                    Swal.fire({
                      icon: "error",
                      title: "ບໍ່ມີໄລຟສົດໃນເພຈເທື່ອ!",
                      html:
                        `<div className="text-left">STEP1: ໄປທີ່ page (${assignedPageList[_pageIndex].name}) <br/> ` +
                        "STEP2 : ເລີ່ມໄລຟວິດີໂອແລ້ວລໍຖ້າຈົນກວ່າການກະກຽມນັ້ນສໍາເລັດ<br/>" +
                        "STEP3 : ກັບຄືນມາຫນ້ານີ້ແລ້ວກົດ ເລີ່ມໄລຟ ໄດ້ເລີຍ</div>",
                      showConfirmButton: false,
                      timer: 20000,
                    });
                  }
                }
              }
            );
          }
        } catch (err) {
          setIsLoading(false);
          return;
        }
      }, 2000);
    }
  }, [liveShopStockDataForValidate])

  const _updatePageToLive = async (page) => {
    try {
      await updateLive({
        variables: {
          where: {
            id: LIVE_DATA?.id,
          },
          data: {
            page: page.id,
            pageName: page.name,
            pageAccessToken: page.access_token
          },
        },
      });
    } catch (error) {
      console.log(error)
    }
  }

  const connectFB = () => {
    window.FB.login((response) => {
      if (response.authResponse) {
        let hasPermission = true;
        [
          "public_profile",
          "email",
          "pages_read_engagement",
          "pages_show_list",
          "pages_messaging",
          "pages_manage_metadata",
          "pages_read_user_content",
        ].map((_permisision) => {
          if (!response.authResponse.grantedScopes.includes(_permisision))
            hasPermission = false;
        });
        if (!hasPermission) {
          addToast("ທ່ານຕ້ອງເປີດອະນຸຍາດໃຫ້ເຂົ້າເຖິງຂໍ້ມູນບໍ່ຄົບຖ້ວນ", {
            appearance: "error",
            autoDismiss: true,
          });
          setShowErrorPermissionModal(true);
          return;
        }
        // console.log("\nresponse.authResponse.accessToken: ", response.authResponse.accessToken);
        setFbUserAccessToken(response.authResponse.accessToken);
        // Update redux store
        updateFbdata({
          fbUserAccessToken: response.authResponse.accessToken,
        });

        addToast("ເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
      } else
        errorTitleWithTextSwal(
          "ມີຂໍ້ຜິດພາດ",
          "ໃນການເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກ ລອງໃຫມ່ອີກຄັ້ງ"
        );
    },
      {
        scope: `public_profile,email,
                       pages_show_list,
                       pages_read_engagement,
                       pages_messaging,
                       pages_manage_metadata,
                       pages_read_user_content`,
        return_scopes: true,
        auth_type: "rerequest",
      }
    );
  };

  const logOutOfFB = useCallback(() => {
    removeFbdata();
    window.FB.logout(() => { });
  }, []);

  const checkLivePage = (_live) => {
    let isMatched = false;
    assignedPageList.map((page, pIndex) => {
      if (page?.id == _live.page) isMatched = true;
    });
    return isMatched;
  };

  const _changeSeletedPage = async (e, live) => {
    // console.log("live: ", live)
    // console.log("e.target.value: ", e.target.value)
    if (e.target.value) {
      let _selectPageFilter = _.filter(assignedPageList, { id: e.target.value });
      // console.log("_selectPageFilter: ", _selectPageFilter);

      setSelectedPage(_selectPageFilter[0])
    } else {
      setSelectedPage({})
    }
  };

  const _goLiveScreen = async (live, isContinueA) => {
    setIsLoading(true);
    await checkPoint();
  };

  const checkPoint = async () => {
    try {
      const SHOP_ID = localStorage.getItem("SHOP");
      await getShop({
        variables: {
          where: {
            id: SHOP_ID,
          },
        },
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  if (isLoading) return <div style={{ display: 'flex', flexDirection: "column", width: '100%', marginTop: 32, justifyContent: 'center', alignItems: 'center' }}>
    <div className="spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>

  return (
    <div style={{ marginTop: 50, padding: 10 }}>
      <div style={{ width: "100%", height: "90vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <img src={SELECT_PAGE_IMAGE} style={{ width: "auto", height: 147 }} />
        <div style={{ height: 32 }} />
        <div>
          {!fbUserAccessToken ? (
            <button
              className="btn btn-light"
              onClick={() => connectFB()}
            >
              ເຊື່ອມຕໍ່ເຟສບຸກ
            </button>
          ) : (
            <button
              className="btn btn-outline-secondary"
              onClick={logOutOfFB}
            >
              {" "}
              <FontAwesomeIcon icon={faSignOutAlt} /> ຍົກເລີກເຊື່ອມເຟສບຸກ
            </button>
          )}
        </div>
        <div style={{ height: 32 }} />
        <div>
          {!fbUserAccessToken ? <p>ກະລຸນາເຊື່ອມຕໍ່ Facebook ກ່ອນ</p> : (
            <Form.Control
              as="select"
              value={selectedPage?.id ?? ""}
              onChange={(e) => _changeSeletedPage(e, LIVE_DATA)}
              disabled={LIVE_DATA?.status != "CREATED"}
            >
              <option value="">ເລືອກເພຈເຊື່ອມຕໍ່</option>
              {assignedPageList?.map((page, pIndex) => {
                return (
                  <option
                    value={page?.id}
                    key={"page" + pIndex}
                  >
                    {page?.name}
                  </option>
                );
              })}
            </Form.Control>
          )}
        </div>
        <div style={{ height: 150 }} />
        <div>
          <button
            className="btn hoverme"
            onClick={() => {
              setIsLoading(true);
              setSelectedLive(LIVE_DATA);
              setIsContinue(false);
              _goLiveScreen(LIVE_DATA, false);
            }}
            disabled={!fbUserAccessToken}
            style={{
              borderColor: COLOR_APP,
              color: COLOR_APP,
            }}
          >
            <FontAwesomeIcon
              icon={faVideo}
              style={{
                borderColor: COLOR_APP,
                color: COLOR_APP,
              }}
            />
            ເລີ່ມໄລຟ
          </button>
        </div>
      </div>

      <ErrorPermissionModal
        showErrorPermissionModal={showErrorPermissionModal}
        setShowErrorPermissionModal={setShowErrorPermissionModal}
      />
    </div>
  )
}


const mapStateToProps = (state) => {
  return {
    fbdata: state.fbdata,
  };
};

export default connect(mapStateToProps)(SelectPageForLive);
